import { useCallback, useEffect, useMemo } from 'react';
import { Dropdown, SimpleSelectList } from 'component-library';
import { useTranslation } from 'react-i18next';
import { type ListDropdownItem } from '@sr/types';
import { type SelectHierarchyProps } from '../../types';
import partnerDetailsToDropdownItem from '../utils/partnerDetailsToDropdownItem';

const SelectHierarchy = ({ hierarchies, onChange, selected, disabled }: SelectHierarchyProps) => {
  const { t } = useTranslation();
  const items: ListDropdownItem[] | undefined = useMemo(
    () => hierarchies?.map((val) => partnerDetailsToDropdownItem(val)),
    [hierarchies],
  );

  const handleChange = useCallback(
    (val: string[]) => {
      onChange(val);
    },
    [onChange],
  );

  useEffect(() => {
    if (hierarchies?.length === 1) {
      handleChange([hierarchies[0].dwKey]);
    }
  }, [hierarchies, handleChange]);

  return (
    items &&
    hierarchies &&
    hierarchies.length > 1 && (
      <Dropdown
        label={t('co2_impact.checkout.selecthierarchy.title')}
        items={items}
        error={false}
        errorMessage="error message"
        selectedValues={selected ?? []}
        placeholder={t('co2_impact.checkout.selecthierarchy.placeholder')}
        onChange={handleChange}
        multiSelect={false}
        loading={false}
        disabled={disabled}
      >
        <SimpleSelectList />
      </Dropdown>
    )
  );
};

export default SelectHierarchy;
